import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filter',
  standalone: false,
})
@Injectable()
export class FilterPipe implements PipeTransform {
  public transform<T>(items: T[], field: keyof T, value: unknown): T[] {
    if (!items) {
      return [];
    }
    if (value === null || ((typeof value === 'string' || Array.isArray(value)) && value.length === 0)) {
      return items;
    }
    return items.filter((i) => i[field] === value);
  }
}
